import QuestionList from '../components/QuestionList';
import {connect} from 'react-redux';
import { byTitle } from '../reducer';
import { withRouter } from 'react-router'
import { deleteCategory } from '../actions/category';

let mapStateToProps = (state, ownProps) => {
  return {
    categories: state.categories.slice().filter((c) => c.type === 'question').sort(byTitle),
    questions: state.questions.slice().sort(byTitle),
    isTranslation: state.route.locationBeforeTransitions.pathname.includes("translation"),
    translation: state.translations.find(t => t.id === parseInt(ownProps.params.trID))
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
    deleteCategory: (id, reassignmentCategoryID) => dispatch(deleteCategory(id, reassignmentCategoryID))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(QuestionList));
